import { GlobalState } from '../../reducers';

export const getGoogleOauth2Status = (state: GlobalState) =>
  state?.auth?.googleOauth2Status;
